import { utils, writeFile } from 'xlsx'  
import { ProductsNotSearched, ResearchedProduct } from "@/types/MarketResearch"
import { structData } from '.'
 
export const useProductMarketResearchSpreadsSheet = () => {
    
    const getTableRowsCycle = (positionData: ResearchedProduct[])  =>
        positionData.map((row) => {
            const obj = {} as Record<string, any>

            obj['Revenda'] = row.DS_REVENDA 
            obj['Representante'] = row.NM_USUARIO
            obj['PDV'] = row.DS_NOME_FANTASIA 
            obj['Produto'] = row.DS_PRODUTO 
            obj['Vl. Compra'] =  Number(row.VL_PRECO_COMPRA)
            obj['Qtd. Compra'] =  Number(row.QTD_VOLUME_COMPRA)
            obj['Vl. Venda'] =  Number(row.VL_PRECO_VENDA)
            obj['Status Lançamento'] = row.DD_STATUS
            obj['Dt. Publicação'] = row.DT_PUBLICACAO ? new Date(row.DT_PUBLICACAO) : null 
            return obj
    })

    const getTableRowsProductsNotSearched = (productsNotSearched: ProductsNotSearched[])  =>
        productsNotSearched.map((row) => {
            const obj = {} as Record<string, any>

            obj['Revenda'] = row.DS_REVENDA 
            obj['Representante'] = row.NM_FUNCIONARIO 
            obj['Cliente'] = row.DS_NOME_FANTASIA 
            obj['Produto'] = row.DS_PRODUTO  
            return obj
    })

    const onDownload = (structData: structData[], dataProductsNotSearched: ProductsNotSearched[]) => { 

        const workbook = utils.book_new()

        structData.forEach(cycle => {
            const rows = getTableRowsCycle(cycle.dataResearchedProducts) 
            const colluns = 8; 

            const formatDate = 'dd/mm/yyyy hh:mm'
            const formatMoneyAccounting = '_-* #,##0.00_-;-* #,##0.00_-;_-* "-"??_-;_-@_-' 

            const worksheet = utils.aoa_to_sheet([[]]);
             
            if(rows.length > 0) {
                utils.sheet_add_json(worksheet, rows, {
                    origin: { r: 0, c: 0 } 
                });

                for (let i = 2; i <= rows.length + 1; i++) { 
                    
                    worksheet[`H${i}`].z = formatDate 
                    
                    worksheet[`D${i}`].z = formatMoneyAccounting
                    worksheet[`F${i}`].z = formatMoneyAccounting 
                }

                worksheet["!cols"] =  Array(colluns).fill({ wch: 20 }); 
            }


            utils.book_append_sheet(workbook, worksheet, `${cycle.cycle}`)
        })

        const worksheet = utils.aoa_to_sheet([[]]);
        const rows = getTableRowsProductsNotSearched(dataProductsNotSearched)
        if(rows.length > 0) {
            utils.sheet_add_json(worksheet, rows, {
                origin: { r: 0, c: 0 } 
            });

            worksheet["!cols"] =  Array(3).fill({ wch: 20 }); 
        } 
        
        utils.book_append_sheet(workbook, worksheet, `Pendentes de pesquisa`)

        const currentDate = new Date();
        const day = currentDate.getDate().toString().padStart(2, '0');
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const year = currentDate.getFullYear().toString();
        const currentDateFormated =  day + month + year;

        writeFile(workbook, `Pesquisa_${currentDateFormated}.xlsx`, {
            compression: true,
            cellStyles: true
        })
    }

    return {
        onDownload,
    }
}
